import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaArrowRight, FaArrowLeft } from 'react-icons/fa';

const NewsGrid = ({ news }) => {
  const [startIndex, setStartIndex] = useState(0);
  
  const handleNext = () => {
    setStartIndex((prev) => (prev + 2 >= news.length ? 0 : prev + 2));
  };
  
  const handlePrev = () => {
    setStartIndex((prev) => (prev - 2 < 0 ? Math.max(0, news.length - 2) : prev - 2));
  };

  // Hiển thị 2 tin tức từ vị trí startIndex
  const visibleNews = news.length > 0 ? news.slice(startIndex, startIndex + 2) : [];
  
  // Thêm tin trống nếu không đủ 2 tin
  while (visibleNews.length < 2) {
    visibleNews.push(null);
  }

  if (news.length === 0) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="neon-loader">
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full">
      {/* Controls */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white">
          CẬP NHẬT
        </h2>
        
        <div className="flex space-x-4 ml-auto">
          <button 
            onClick={handlePrev}
            className="w-10 h-10 rounded-full flex items-center justify-center bg-dark/70 text-light hover:bg-accent-teal transition-all"
            aria-label="Previous news"
          >
            <FaArrowLeft />
          </button>
          
          <button 
            onClick={handleNext}
            className="w-10 h-10 rounded-full flex items-center justify-center bg-dark/70 text-light hover:bg-accent-teal transition-all"
            aria-label="Next news"
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
      
      {/* News Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {visibleNews.map((item, index) => (
          item ? (
            <Link 
              key={item.id} 
              to={`/news/${item.slug}`}
              className="block"
            >
              <motion.div 
                className="news-card rounded-xl overflow-hidden relative"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{ y: -5, transition: { duration: 0.2 } }}
              >
                <div 
                  className="aspect-[1052/510] bg-cover bg-center"
                  style={{ backgroundImage: `url(${item.image})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/40 to-transparent hover:from-dark/90 hover:via-dark/50 transition-all duration-300"></div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-xl md:text-2xl font-bold mb-3 text-white text-shadow-lg">
                      {item.title}
                    </h3>
                    
                    <p className="text-light/80 line-clamp-2 mb-4">
                      {item.summary}
                    </p>
                    
                    <div className="flex items-center">
                      <FaCalendarAlt className="text-accent-teal mr-2" />
                      <span className="text-light/90 text-sm">{item.date}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            </Link>
          ) : (
            <div key={`empty-${index}`} className="hidden md:block"></div>
          )
        ))}
      </div>
      
      {/* Indicator dots */}
      {news.length > 2 && (
        <div className="flex justify-center mt-6 space-x-2">
          {Array.from({ length: Math.ceil(news.length / 2) }).map((_, index) => (
            <button
              key={index}
              onClick={() => setStartIndex(index * 2)}
              className={`w-2 h-2 rounded-full ${startIndex === index * 2 ? 'bg-accent-teal w-6' : 'bg-light/30'} transition-all`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default NewsGrid;
